import React, { useContext, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import AuthContext from "../../../context/auth-context";
import UpperbarContext from "../../../context/upperbar-context";
import Toast from "../../../Toast";
import "../ledger report/ledger.css";
import { Fetchdata } from "../../../hooks/getData";
import Spinner from "../../../loading/spinner";
import { englishToNepaliNumber } from "nepali-number";

export default function Summary() {
  const { User } = useContext(AuthContext);

  //   const searchInput = useRef("");
  const { fiscalYear, todayDate, appURL, userDetails, darkText, mode } =
    useContext(UpperbarContext);

  const [loading, setLoading] = useState(true);
  //   API to account group list

  const [acGrpList, setAcGrpList] = useState([]);

  useEffect(() => {
    accLst();
  }, []);

  const accLst = () => {
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      DFlag: "ACCGROUP",
      IsPrimary: "N",
      Flag: "S",
      CID: "1",
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/ref-values`,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";
        setAcGrpList(postResult);
      } else {
        setAcGrpList([]);
      }
    });
  };

  const initalvalue = {
    acHead: "-1",
  };
  const [inputValues, setInputValues] = useState(initalvalue);

  const handleOnChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  //   API to day book list
  const [summaryList, setSummaryList] = useState([]);

  useEffect(() => {
    summaryLst();
  }, [inputValues.acHead]);

  const summaryLst = () => {
    const Branch = "" + User.BranchID;
    const Fiscal = "" + User.FiscalID;
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      CID: "1",
      Flag: "S",
      DFlag: "SS",
      DtFlag: "N",
      AcGroupID: inputValues.acHead,
      // Values: inputValues.specificDate,
      BranchID: Branch,
      FiscalID: Fiscal,
      Type: "POST",
      FetchURL: `${appURL}api/acc/report/ledger`,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";
        setSummaryList(postResult);
        setLoading(false);
      } else {
        setSummaryList([]);
        setLoading(false);
      }
    });
  };

  let dr = summaryList.reduce(function (prev, current) {
    return prev + +current.DrAmt;
  }, 0);
  let cr = summaryList.reduce(function (prev, current) {
    return prev + +current.CrAmt;
  }, 0);
  let total = dr - cr;

  return (
    <>
      {/* <Toast /> */}

      <>
        <div className="upper-dataTbl">
          <div className="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle mb-3">
            <div className="uk-flex uk-flex-wrap me-5">
              <div className="me-2 mt-3">
                <label className="d-block text-start dark-gray mb-1">
                  {mode === "en"
                    ? "Select Account Head"
                    : "खाता प्रमुख चयन गर्नुहोस्"}
                </label>
                <select
                  style={{ fontSize: "11px" }}
                  name="acHead"
                  value={inputValues.acHead}
                  onChange={handleOnChange}
                  className="form-select form-select-sm"
                >
                  <option
                    value=""
                    disabled
                    selected
                    style={{ fontSize: "11px" }}
                  >
                    {mode === "en"
                      ? "Select Account Head"
                      : "खाता प्रमुख चयन गर्नुहोस्"}
                  </option>
                  <option value="-1">{mode === "en" ? "All" : "सबै"}</option>
                  {acGrpList.map((props) => {
                    return (
                      <option key={props.AccGroupID} value={props.AccGroupID}>
                        {props.AccGroup}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3" style={{ overflow: "auto" }}>
          {loading ? (
            <Spinner />
          ) : (
            <>
              {summaryList.length > 0 ? (
                <table className="uk-table reportTable">
                  <thead>
                    <tr>
                      <td
                        className="rdt_TableHeadRow tableHead text-center"
                        width="70px"
                      >
                        {mode === "en" ? "S.N." : "क्र.सं"}
                      </td>
                      <td className="rdt_TableHeadRow tableHead">
                        {mode === "en" ? "Ledger" : "लेजर"}
                      </td>

                      <td
                        className="rdt_TableHeadRow tableHead text-end"
                        width="150px"
                      >
                        {mode === "en" ? "Debit Amount" : "डेबिट रकम"}
                      </td>
                      <td
                        className="rdt_TableHeadRow tableHead text-end"
                        width="150px"
                      >
                        {mode === "en" ? "Credit Amount" : "क्रेडिट रकम"}
                      </td>
                      <td
                        className="rdt_TableHeadRow tableHead text-end"
                        width="150px"
                      >
                        {mode === "en" ? "Balance" : "सन्तुलन"}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    {summaryList.map((data, i) => {
                      const total = Math.abs(data.DrAmt - data.CrAmt);
                      return (
                        <tr>
                          <td
                            style={{ minWidth: "70px" }}
                            className="rdt_TableCell tablecell text-center"
                          >
                            {mode === "en"
                              ? i + 1
                              : englishToNepaliNumber(i + 1)}
                          </td>
                          <td
                            style={{ minWidth: "200px" }}
                            className="rdt_TableCell tablecell "
                          >
                            {data.Ledger}
                          </td>
                          <td
                            style={{ minWidth: "150px" }}
                            className="rdt_TableCell tablecell text-end"
                          >
                            {data.DrAmt.toFixed(2)}
                          </td>
                          <td
                            style={{ minWidth: "150px" }}
                            className="rdt_TableCell tablecell text-end"
                          >
                            {data.CrAmt.toFixed(2)}
                          </td>
                          <td
                            style={{ minWidth: "150px" }}
                            className="rdt_TableCell tablecell text-end"
                          >
                            {total.toFixed(2)} {""}
                            {""}
                            {data.CrAmt > data.DrAmt ? "CR" : "DR"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                  <tfoot>
                    <tr className="reportTotal">
                      <td
                        className="rdt_TableCell tablecell text-end fw-bold"
                        colSpan={2}
                      >
                        {mode === "en" ? "Total" : "कुल"}
                      </td>
                      <td className="rdt_TableCell tablecell text-end fw-bold">
                        {dr.toFixed(2)}
                      </td>
                      <td className="rdt_TableCell tablecell text-end fw-bold">
                        {cr.toFixed(2)}
                      </td>
                      <td className="rdt_TableCell tablecell text-end fw-bold">
                        {Math.abs(total).toFixed(2)}
                        {""} {cr > dr ? "CR" : "DR"}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              ) : (
                <p className="text-center">
                  {mode === "en" ? "No Data" : "डाटा उपलब्ध छैन"}
                </p>
              )}
            </>
          )}
        </div>
      </>
    </>
  );
}
